import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SerialNumbers_ds_get_serialnumber_by_codeService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { code: string, licensePlateId?: number, locationId?: number, warehouseId?: number, shippingContainerId?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.code)) {
      missingRequiredInParams.push('\'code\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serialnumber_by_code/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { code: string, licensePlateId?: number, locationId?: number, warehouseId?: number, shippingContainerId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.code)) {
      missingRequiredInParams.push('\'code\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serialnumber_by_code/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { code: string, licensePlateId?: number, locationId?: number, warehouseId?: number, shippingContainerId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.code)) {
      missingRequiredInParams.push('\'code\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serialnumber_by_code/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
